// 訂單相關翻譯

export const orders = {
    orderList: '訂單列表',
    orderNo: '訂單號',
    email: '郵箱',
    productName: '產品名稱',
    amount: '金額',
    paidAt: '支付時間',
    noOrderRecords: '暫無訂單記錄',
    noOrders: '暫無訂單',
    noOrdersDescription: '您還沒有任何訂單記錄',
    status: '狀態',
    credits: '積分',
    operations: '操作',
    refund: '退款',
    refunding: '退款中...',
    refundSuccess: '退款申請提交成功',
    refundFailed: '退款申請失敗',
    refundConfirm: '確定要申請退款此訂單嗎？',
    refundNotAvailable: '不可退款',
    statusCompleted: '已完成',
    statusPending: '待處理',
    statusFailed: '失敗',
    statusCancelled: '已取消',
    statusRefunded: '已退款'
  };
